import { ethers } from 'ethers';

export const parseBNBHandle = (val: string) => {
    return ethers.parseEther(val)
}



export const parseUsdtHandle = (val: string) => {
    return ethers.parseUnits(val, 18)
}

